import styled from 'styled-components';

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.error || '#EF4444'};
  font-size: 12px;
`;

export const UploadPhotoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  & > .drag-and-drop {
    height: 179px;
    padding: 24px 0;
  }
`;

